// extracted by mini-css-extract-plugin
export default {"container":"Properties_container__I4NVq","wrapper":"Properties_wrapper__7v9Ob","box":"Properties_box__wY1ov","boxImg":"Properties_boxImg__sZ61c"};